// extracted by mini-css-extract-plugin
var _1 = "AreaDropdownImage_badge__26356";
var _2 = "AreaDropdownImage_disabled__8a2d8";
var _3 = "AreaDropdownImage_empty__80fe5";
var _4 = "AreaDropdownImage_emptyIcon__0210f";
var _5 = "AreaDropdownImage_img__7ddcb";
var _6 = "AreaDropdownImage_imgContainer__f1a87";
var _7 = "AreaDropdownImage_label__05e16";
var _8 = "AreaDropdownImage_mask__b9d21";
var _9 = "AreaDropdownImage_root__325d3";
var _a = "AreaDropdownImage_selected__0c27c";
export { _1 as "badge", _2 as "disabled", _3 as "empty", _4 as "emptyIcon", _5 as "img", _6 as "imgContainer", _7 as "label", _8 as "mask", _9 as "root", _a as "selected" }
